import {
  faArrowsLeftRightToLine,
  faExpand,
  faObjectsAlignCenterHorizontal,
  faObjectsAlignCenterVertical,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Divider, Stack } from "@mui/material";

import {
  bindMenu,
  bindMenuTrigger,
  IconButton,
  useMenuState,
  useTheme,
} from "@/components/ui-v2";
import { AspectRatio } from "@/types";

import { AspectRatioPicker } from "./AspectRatioPicker";

interface ToolbarProps {
  onSnap: (direction: "width" | "height") => void;
  onCenter: (axis: "x" | "y") => void;

  aspectRatios: AspectRatio[];
  aspectRatio: AspectRatio;
  onAspectRatioChange?: (aspectRatio: AspectRatio) => void;
}

export const Toolbar = (props: ToolbarProps) => {
  const { onSnap, onCenter, aspectRatios, aspectRatio, onAspectRatioChange } =
    props;
  const theme = useTheme();
  const aspectRatioState = useMenuState();

  return (
    <>
      <Stack
        spacing={2}
        direction="row"
        divider={<Divider orientation="vertical" flexItem />}
        sx={{
          // TODO: All this positioning should be done in the parent component
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          backgroundColor: theme.palette.secondary[6],
          borderRadius: 2,
          border: `1px solid ${theme.palette.secondary[5]}`,
          padding: 2,
          bottom: 2,
        }}
      >
        <Box>
          <IconButton
            {...bindMenuTrigger(aspectRatioState)}
            size="small"
            aria-label="Aspect Ratio"
            tooltip
            variant="quaternary"
          >
            <FontAwesomeIcon icon={faExpand} />
          </IconButton>
        </Box>
        <Stack
          direction="row"
          sx={{
            gap: 1,
          }}
        >
          <IconButton
            onClick={() => onCenter("x")}
            size="small"
            aria-label="Center horizontally"
            tooltip
            variant="quaternary"
          >
            <FontAwesomeIcon icon={faObjectsAlignCenterHorizontal} />
          </IconButton>
          <IconButton
            onClick={() => onCenter("y")}
            size="small"
            aria-label="Center vertically"
            tooltip
            variant="quaternary"
          >
            <FontAwesomeIcon icon={faObjectsAlignCenterVertical} />
          </IconButton>
          <IconButton
            onClick={() => onSnap("width")}
            size="small"
            aria-label="Snap to width"
            tooltip
            variant="quaternary"
          >
            <FontAwesomeIcon icon={faArrowsLeftRightToLine} />
          </IconButton>
          <IconButton
            onClick={() => onSnap("height")}
            size="small"
            aria-label="Snap to height"
            tooltip
            variant="quaternary"
          >
            <FontAwesomeIcon
              icon={faArrowsLeftRightToLine}
              style={{ transform: "rotate(90deg)" }}
            />
          </IconButton>
        </Stack>
      </Stack>
      <AspectRatioPicker
        {...bindMenu(aspectRatioState)}
        aspectRatios={aspectRatios}
        value={aspectRatio}
        onChange={onAspectRatioChange}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      />
    </>
  );
};
